import React from 'react';
import PropTypes from 'prop-types';
import SVGWrap from './SVGWrap';

const Calendar = ({ outlineColor, s }) => (
  <SVGWrap style={s}>
    <path
      fill={outlineColor}
      d="M451.6,508.9H59.7c-33.9,0-60.4-26.5-60.4-60.4V111c0-33.9,26.5-60.4,60.4-60.4H100c5.6,0,10.1,4.5,10.1,10.1
	c0,5.6-4.5,10.1-10.1,10.1H59.7c-22.6,0-40.3,17.7-40.3,40.3v93.7h472.4V111c0-22.6-17.7-40.3-40.3-40.3h-40.3
	c-5.6,0-10.1-4.5-10.1-10.1c0-5.6,4.5-10.1,10.1-10.1h40.3c33.9,0,60.4,26.5,60.4,60.4v337.4C512,482.3,485.5,508.9,451.6,508.9z
	 M19.4,224.8v223.6c0,22.6,17.7,40.3,40.3,40.3h391.8c22.6,0,40.3-17.7,40.3-40.3V224.8H19.4z M327.7,70.7h-143
	c-5.6,0-10.1-4.5-10.1-10.1c0-5.6,4.5-10.1,10.1-10.1h143c5.6,0,10.1,4.5,10.1,10.1C337.7,66.2,333.2,70.7,327.7,70.7z"
    />
    <path
      fill={outlineColor}
      d="M152.4,97.1V11.3c0-5.6-4.5-10.1-10.1-10.1s-10.1,4.5-10.1,10.1v85.8c-18.5,4.5-32.2,21.2-32.2,41.1
	c0,23.3,19,42.3,42.3,42.3s42.3-19,42.3-42.3C184.6,118.3,170.9,101.6,152.4,97.1z M142.3,160.4c-12.2,0-22.2-9.9-22.2-22.2
	c0-12.2,9.9-22.2,22.2-22.2c12.2,0,22.2,10,22.2,22.2C164.5,150.4,154.5,160.4,142.3,160.4z"
    />
    <path
      fill={outlineColor}
      d="M379,97.1V11.3c0-5.6-4.5-10.1-10.1-10.1c-5.6,0-10.1,4.5-10.1,10.1v85.8c-18.5,4.5-32.2,21.2-32.2,41.1
	c0,23.3,19,42.3,42.3,42.3c23.3,0,42.3-19,42.3-42.3C411.3,118.3,397.5,101.6,379,97.1z M369,160.4c-12.2,0-22.2-9.9-22.2-22.2
	c0-12.2,9.9-22.2,22.2-22.2c12.2,0,22.2,10,22.2,22.2C391.1,150.4,381.2,160.4,369,160.4z"
    />
    <path
      fill={outlineColor}
      d="M200.8,426.3C200.7,426.3,200.7,426.3,200.8,426.3c-2.7,0-5.3-1.1-7.2-3l-57.4-58.4c-3.9-4-3.8-10.3,0.1-14.2
	c4-3.9,10.3-3.9,14.2,0.1l50.3,51.2l129.8-129.8c3.9-3.9,10.3-3.9,14.2,0c3.9,3.9,3.9,10.3,0,14.2l-137,137
	C206,425.2,203.4,426.3,200.8,426.3z"
    />
  </SVGWrap>
);

Calendar.defaultProps = {
  outlineColor: '#000000',
  s: {},
};

Calendar.propTypes = {
  outlineColor: PropTypes.string,
  s: PropTypes.object,
};

export default Calendar;
